import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import { descargarPresupuestoPdf } from './presupuestoPdfUtils';
import axios from '../../axios/axiosconf';
import { getSpaPathPrefix } from '../../../resources/Constants';
import { Toast, ToastContainer } from 'react-bootstrap';

function ListadoPresupuestos() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [presupuestos, setPresupuestos] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [pacientes, setPacientes] = useState([]);
    const [encabezadosPersonalizados, setEncabezadosPersonalizados] = useState({});

    // Filtros
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [usuarioFiltro, setUsuarioFiltro] = useState('');
    const [busquedaPaciente, setBusquedaPaciente] = useState('');
    const [estadoFiltro, setEstadoFiltro] = useState('');

    // Paginación
    const [paginaActual, setPaginaActual] = useState(1);
    const registrosPorPagina = 12;

    // Nuevo Sistema de Acciones en Modal
    const [showModalAcciones, setShowModalAcciones] = useState(false);
    const [presupuestoAccion, setPresupuestoAccion] = useState(null);

    /** Alertas superiores solo para error / aviso (no éxito) */
    const [feedback, setFeedback] = useState(null);

    /** Toast inferior — mismo criterio que Footer / otras pantallas (éxito) */
    const [showToast, setShowToast] = useState(false);
    const [toastMsg, setToastMsg] = useState('');

    const mostrarFeedback = (tipo, mensaje) => {
        if (tipo === 'success') {
            setToastMsg(mensaje);
            setShowToast(true);
            return;
        }
        setFeedback({ tipo, mensaje });
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        // Establecer fechas de la semana actual por defecto
        const hoy = new Date();
        const inicioSemana = new Date(hoy.setDate(hoy.getDate() - hoy.getDay()));
        const finSemana = new Date(hoy.setDate(hoy.getDate() - hoy.getDay() + 6));

        setFechaInicio(inicioSemana.toISOString().split('T')[0]);
        setFechaFin(finSemana.toISOString().split('T')[0]);

        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar usuarios del cliente (incluyendo inactivos para mostrar nombres en presupuestos históricos)
        axios.get('/users-by-client?uid=' + userdata.user_id + '&incluir_inactivos=true', config)
            .then(response => {
                if (response.status === 200) {
                    setUsuarios(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Pacientes + empresas (tipo_cliente=1) para nombres y PDF
        // Incluye pacientes con tipo_cliente NULL (datos de migración) que se tratan como pacientes normales
        Promise.all([
            axios.get('/pacientes', { ...config, params: { uid: userdata.user_id, incluir_todos: true } }),
            axios.get('/pacientes', { ...config, params: { uid: userdata.user_id, solo_empresas: true } })
        ])
            .then(([respPacientes, respEmpresas]) => {
                const listaPacientes = Array.isArray(respPacientes.data) ? respPacientes.data : [];
                const listaEmpresas = Array.isArray(respEmpresas.data) ? respEmpresas.data : [];
                const combinados = [...listaPacientes, ...listaEmpresas];
                const unicos = Array.from(new Map(combinados.map(item => [item.id, item])).values());
                setPacientes(unicos);
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    }, []);

    useEffect(() => {
        if (loggedIn && fechaInicio && fechaFin) {
            cargarPresupuestos();
        }
    }, [loggedIn, fechaInicio, fechaFin, usuarioFiltro, estadoFiltro]);

    useEffect(() => {
        if (loggedIn && fechaInicio && fechaFin) {
            const timeoutId = setTimeout(() => {
                cargarPresupuestos();
            }, 500);
            return () => clearTimeout(timeoutId);
        }
    }, [busquedaPaciente]);

    const cargarPresupuestos = () => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        const params = new URLSearchParams({
            uid: userdata.user_id,
            fecha_inicio: fechaInicio,
            fecha_fin: fechaFin
        });

        if (usuarioFiltro) params.append('usuario_id', usuarioFiltro);
        if (busquedaPaciente) params.append('busqueda_paciente', busquedaPaciente);
        if (estadoFiltro !== '') params.append('estado', estadoFiltro);

        axios.get('/presupuestos?' + params.toString(), config)
            .then(response => {
                if (response.status === 200) {
                    setPresupuestos(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    };

    // Cálculos para tarjetas de resumen
    const totales = presupuestos.reduce((acc, p) => {
        const valorTotal = parseFloat(p.valor_total || 0);
        const pagado = parseFloat(p.valor_consumido || 0);
        const pendiente = parseFloat(p.saldo_disponible || 0);

        acc.recuento++;
        acc.total += valorTotal;
        acc.pagado += pagado;
        acc.pendiente += pendiente;
        return acc;
    }, { recuento: 0, total: 0, pagado: 0, pendiente: 0 });

    const getIniciales = (nombre) => {
        if (!nombre || nombre === 'N/A') return '?';
        const partes = nombre.split(' ');
        if (partes.length >= 2) return (partes[0][0] + partes[1][0]).toUpperCase();
        return (partes[0][0] || '').toUpperCase();
    };

    const getNombreMostrarCliente = (p) => {
        if (!p) return '';
        const nombrePersona = `${p.primer_nombre || ''} ${p.segundo_nombre || ''} ${p.primer_apellido || ''} ${p.segundo_apellido || ''}`.trim();
        return nombrePersona || p.razon_social || p.nombre_empresa || p.nombre_comercial || p.nombre || '';
    };

    const getNombrePaciente = (pacienteId) => {
        if (pacienteId == null || pacienteId === '') return 'N/A';
        const paciente = pacientes.find(p => p.id == pacienteId);
        if (!paciente) return 'N/A';
        const s = getNombreMostrarCliente(paciente).trim();
        return s || 'N/A';
    };

    const getNombreUsuario = (usuarioId) => {
        if (!usuarioId) return 'N/A';
        const usuario = usuarios.find(u => String(u.id) === String(usuarioId));
        return usuario ? (usuario.name + (usuario.lastname ? ' ' + usuario.lastname : '')) : 'N/A';
    };

    const getEstadoPresupuestoTexto = (estado) => {
        switch (parseInt(estado)) {
            case 0: return 'Borrador';
            case 1: return 'Activo';
            case 2: return 'Anulado';
            case 3: return 'Pagado';
            default: return 'Desconocido';
        }
    };

    const getEstadoPresupuestoBadge = (estado) => {
        switch (parseInt(estado)) {
            case 0: return 'badge badge-secondary';
            case 1: return 'badge badge-success';
            case 2: return 'badge badge-danger';
            case 3: return 'badge badge-warning';
            default: return 'badge badge-secondary';
        }
    };

    const vistaPreviaPresupuesto = (presupuestoId) => {
        const prefix = getSpaPathPrefix();
        const url = `${window.location.origin}${prefix}/#/vista-previa-presupuesto/${presupuestoId}`;
        window.open(url, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const descargarPDFPresupuesto = async (presupuestoId) => {
        try {
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            const presupuestoResponse = await axios.get(`/presupuesto/${presupuestoId}?uid=${userdata.user_id}`);
            const presupuestoData = presupuestoResponse.data;
            let pacienteData = pacientes.find(p => String(p.id) === String(presupuestoData.paciente_id));
            if (!pacienteData?.numero_documento && presupuestoData.paciente_id) {
                try {
                    const pacienteDetalle = await axios.get(
                        `/paciente?uid=${userdata.user_id}&id=${presupuestoData.paciente_id}`
                    );
                    if (pacienteDetalle.data?.[0]) {
                        pacienteData = pacienteDetalle.data[0];
                    }
                } catch (error) {
                    console.log('No se pudo cargar el detalle del paciente:', error);
                }
            }
            const usuarioData = usuarios.find(u => u.id === presupuestoData.users_id);

            let encabezadoData = null;
            if (presupuestoData.users_id) {
                try {
                    const encabezadoResponse = await axios.get(`/encabezado-personalizado?uid=${presupuestoData.users_id}`);
                    if (encabezadoResponse.status === 200 && encabezadoResponse.data && encabezadoResponse.data.estado === 1) {
                        encabezadoData = encabezadoResponse.data;
                    }
                } catch (error) {
                    console.log('No hay encabezado personalizado for user');
                }
            }

            await descargarPresupuestoPdf({
                presupuesto: presupuestoData,
                client,
                paciente: pacienteData,
                encabezadoPersonalizado: encabezadoData,
                usuario: usuarioData,
            });

        } catch (error) {
            console.error('Error generando PDF:', error);
            mostrarFeedback('danger', 'No se pudo generar el PDF. Intente de nuevo.');
        }
    };

    const enviarEmailPresupuesto = (presupuestoId) => { };

    const eliminarPresupuesto = async (presupuestoId) => {
        if (!window.confirm('¿ELIMINAR presupuesto?')) return;
        try {
            const response = await axios.delete(`/presupuesto/${presupuestoId}`);

            if (response.status === 200) {
                mostrarFeedback('success', 'Presupuesto eliminado correctamente.');
                cargarPresupuestos();
                setShowModalAcciones(false);
            }
        } catch (error) {
            console.error('Error eliminando presupuesto:', error);
            const msg =
                error.response?.data?.message ||
                (error.response?.status === 404
                    ? 'No se encontró el presupuesto en el servidor.'
                    : 'No se pudo eliminar el presupuesto. Intente de nuevo.');
            mostrarFeedback('danger', msg);
        }
    };

    const handleAbrirAcciones = (p) => {
        setPresupuestoAccion(p);
        setShowModalAcciones(true);
    };

    const handleCambioRapidoEstadoAcciones = async (id, nuevoEstado) => {
        const num = presupuestoAccion?.numero_presupuesto;
        await handleCambioRapidoEstado(id, nuevoEstado, num);
        setShowModalAcciones(false);
    };

    const mensajeConfirmacionCambioEstado = (nuevoEstado, numeroPresupuesto) => {
        const ref =
            numeroPresupuesto != null && String(numeroPresupuesto).trim() !== ''
                ? ` N° ${numeroPresupuesto}`
                : '';
        if (nuevoEstado === 1) {
            return `¿Aprobar el presupuesto${ref}? Quedará activo y podrá facturarse.`;
        }
        if (nuevoEstado === 2) {
            return `¿Anular el presupuesto${ref}? Pasará a anulado y no podrá usarse para facturar.`;
        }
        return `¿Cambiar el estado del presupuesto${ref}?`;
    };

    const handleCambioRapidoEstado = async (presupuestoId, nuevoEstado, numeroPresupuesto) => {
        if (!window.confirm(mensajeConfirmacionCambioEstado(nuevoEstado, numeroPresupuesto))) return;
        try {
            const response = await axios.put(`/presupuesto/${presupuestoId}/estado`, { estado: nuevoEstado });
            if (response.data.success) {
                cargarPresupuestos();
            }
        } catch (error) {
            const msg =
                error.response?.data?.message ||
                error.message ||
                'No se pudo cambiar el estado.';
            mostrarFeedback('danger', msg);
        }
    };

    const indiceUltimoRegistro = paginaActual * registrosPorPagina;
    const indicePrimerRegistro = indiceUltimoRegistro - registrosPorPagina;
    const presupuestosPaginados = presupuestos.slice(indicePrimerRegistro, indiceUltimoRegistro);
    const totalPaginas = Math.ceil(presupuestos.length / registrosPorPagina);

    // Paginación compacta para no mostrar 1..50 cuando hay muchas páginas.
    // Regla:
    // - total <= 7: muestra todas
    // - si página actual está al inicio: muestra 1..4 ... last
    // - si está al final: muestra 1 ... last-3..last
    // - en medio: muestra 1 ... (current-1..current+1) ... last
    const getPaginationItems = (current, total) => {
        if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);

        if (current <= 3) return [1, 2, 3, 4, null, total];
        if (current >= total - 2) return [1, null, total - 3, total - 2, total - 1, total];

        return [1, null, current - 1, current, current + 1, null, total];
    };

    const cambiarPagina = (numeroPagina) => setPaginaActual(numeroPagina);

    useEffect(() => {
        setPaginaActual(1);
    }, [fechaInicio, fechaFin, usuarioFiltro, busquedaPaciente, estadoFiltro]);

    if (!loggedIn) return <Loading />;

    return (
        <div className="wrapper hold-transition" style={{ fontSize: '13px' }}>
            <style>{`
                .summary-card { background: #fff; padding: 1.25rem; border-radius: 12px; box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); border: none; transition: transform 0.2s; height: 100%; }
                .summary-card:hover { transform: translateY(-3px); }
                .icon-box { width: 45px; height: 45px; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 1.2rem; margin-right: 15px; }
                .card-label { color: #8c8c8c; font-size: 0.75rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; }
                .card-value { font-size: 1.25rem; font-weight: 700; color: #323a45; }
                .card-subtext { font-size: 0.65rem; color: #bababa; margin-top: 2px; }
                .filter-card { background: #fff; border-radius: 12px; border: none; box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.05); }
                .custom-table { width: 100%; background: #fff; border-radius: 12px; overflow: hidden; }
                .custom-table thead th {
                    background: #f8f9fa; color: #7d7d7d !important; text-transform: uppercase; font-size: 0.7rem !important;
                    font-weight: 700 !important; padding: 12px 15px !important; border: none !important;
                }
                .custom-table tbody tr { border-bottom: 1px solid #f0f0f0; transition: all 0.2s; cursor: pointer; }
                .custom-table tbody tr:hover { background-color: #f9fbff !important; box-shadow: inset 4px 0 0 #17a2b8; }
                .custom-table tbody tr.fila-anulado:hover { background-color: #fff7f7 !important; box-shadow: inset 4px 0 0 #dc3545; }
                .custom-table td { padding: 10px 15px !important; vertical-align: middle !important; border: none !important; font-size: 0.8rem !important; }
                .status-pill {
                    padding: 4px 10px; border-radius: 20px; font-size: 0.7rem; font-weight: 700;
                    display: inline-flex; align-items: center; gap: 4px;
                }
                .status-active { background: #e6f7ff; color: #1890ff; border: 1px solid #91d5ff; }
                .status-paid { background: #f6ffed; color: #52c41a; border: 1px solid #b7eb8f; }
                .status-void { background: #fff1f0; color: #f5222d; border: 1px solid #ffa39e; }
                .table-info { background-color: #f6fcfd !important; box-shadow: inset 4px 0 0 #17a2b8 !important; }
            `}</style>

            <Header client={client} />
            <Aside client={client} activelink="billing" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <ol className="breadcrumb float-sm-left">
                                    <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                    <li className="breadcrumb-item active">Listado de Presupuestos</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2 align-items-center">
                            <div className="col-sm-12 col-md-8">
                                <h1 className="m-0" style={{ fontWeight: 700, fontSize: '1.5rem', color: '#323a45' }}>Listado de Presupuestos</h1>
                            </div>
                            <div className="col-sm-12 col-md-4 mt-2 mt-md-0 text-md-right">
                                <Link to="/crear-presupuesto" className="btn btn-primary" style={{ borderRadius: '10px', padding: '7px 18px', fontSize: '0.9rem' }}>
                                    <i className="fas fa-plus mr-2"></i> Nuevo Presupuesto
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        {feedback && (
                            <div
                                className={`alert alert-${feedback.tipo} alert-dismissible fade show`}
                                role="alert"
                                style={{ borderRadius: '10px' }}
                            >
                                <i
                                    className={`fas mr-2 ${
                                        feedback.tipo === 'success'
                                            ? 'fa-check-circle'
                                            : feedback.tipo === 'warning'
                                                ? 'fa-exclamation-circle'
                                                : 'fa-exclamation-triangle'
                                    }`}
                                ></i>
                                {feedback.mensaje}
                                <button
                                    type="button"
                                    className="close"
                                    onClick={() => setFeedback(null)}
                                    aria-label="Cerrar"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        )}

                        {/* Summary Cards */}
                        <div className="row mb-4">
                            <div className="col-md-3">
                                <div className="summary-card d-flex align-items-center">
                                    <div className="icon-box" style={{background: 'rgb(240, 245, 255)', color: 'rgb(123 136 145)'}}><i className="fas fa-file-invoice"></i></div>
                                    <div><div className="card-label">Presupuestos</div><div className="card-value">{totales.recuento}</div><div className="card-subtext">Total activos</div></div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="summary-card d-flex align-items-center">
                                    <div className="icon-box" style={{background: 'rgb(230, 247, 255)', color: '#17a2b8'}}><i className="fas fa-dollar-sign"></i></div>
                                    <div><div className="card-label">Valor Total</div><div className="card-value">${Math.round(totales.total).toLocaleString('es-CO')}</div><div className="card-subtext">Base facturada</div></div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="summary-card d-flex align-items-center">
                                    <div className="icon-box" style={{ background: '#f6ffed', color: '#52c41a' }}><i className="fas fa-check-circle"></i></div>
                                    <div><div className="card-label">Pagado</div><div className="card-value">${Math.round(totales.pagado).toLocaleString('es-CO')}</div><div className="card-subtext">{Math.round((totales.pagado / (totales.total || 1)) * 100)}% cobrado</div></div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="summary-card d-flex align-items-center">
                                    <div className="icon-box" style={{ background: '#fff7e6', color: '#faad14' }}><i className="fas fa-clock"></i></div>
                                    <div><div className="card-label">Pendiente</div><div className="card-value">${Math.round(totales.pendiente).toLocaleString('es-CO')}</div><div className="card-subtext">Por cobrar</div></div>
                                </div>
                            </div>
                        </div>

                        {/* Filtros */}
                        <div className="filter-card p-4 mb-4">
                            <div className="row">
                                <div className="col-md-2"><label className="small font-weight-bold text-uppercase text-muted">Fecha Inicio</label><input type="date" className="form-control" value={fechaInicio} onChange={e => setFechaInicio(e.target.value)} /></div>
                                <div className="col-md-2"><label className="small font-weight-bold text-uppercase text-muted">Fecha Fin</label><input type="date" className="form-control" value={fechaFin} onChange={e => setFechaFin(e.target.value)} /></div>
                                <div className="col-md-3"><label className="small font-weight-bold text-uppercase text-muted">Usuario</label><select className="form-control" value={usuarioFiltro} onChange={e => setUsuarioFiltro(e.target.value)}><option value="">Todos</option>{usuarios.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}</select></div>
                                <div className="col-md-2"><label className="small font-weight-bold text-uppercase text-muted">Estado</label><select className="form-control" value={estadoFiltro} onChange={e => setEstadoFiltro(e.target.value)}><option value="">Todos</option><option value="0">Borrador</option><option value="1">Activo</option><option value="2">Anulado</option><option value="3">Pagado</option></select></div>
                                <div className="col-md-3"><label className="small font-weight-bold text-uppercase text-muted">Buscar Paciente</label><input type="text" className="form-control" placeholder="Nombre..." value={busquedaPaciente} onChange={e => setBusquedaPaciente(e.target.value)} /></div>
                            </div>
                        </div>

                        {/* Tabla */}
                        <div className="card shadow-sm border-0" style={{borderRadius: '16px', overflow: 'hidden'}}>
                            <div className="card-body p-0" style={{overflowX: 'auto', minHeight: '280px'}}>
                                <table className="table custom-table mb-0" style={{minWidth: '900px'}}>
                                    <thead>
                                        <tr>
                                            <th>N° Presupuesto</th>
                                            <th>Fecha</th>
                                            <th>Paciente</th>
                                            <th>Profesional</th>
                                            <th className="text-right">Total</th>
                                            <th className="text-center">Estado</th>
                                            <th className="text-center" width="100">ACCIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {presupuestosPaginados.map((p, index) => {
                                            const nombre = getNombrePaciente(p.paciente_id);
                                            const est = parseInt(p.estado);

                                            return (
                                                <tr key={p.id} className={est === 2 ? 'fila-anulado' : ''}>
                                                    <td><span style={{ color: '#17a2b8', fontWeight: 700 }}>#{p.numero_presupuesto}</span></td>
                                                    <td style={{ color: '#6c757d' }}>{new Date(p.fecha_creacion).toLocaleDateString()}</td>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <div style={{ fontWeight: 600, color: '#434343' }}>{nombre}</div>
                                                        </div>
                                                    </td>
                                                    <td style={{ color: '#8c8c8c' }}>{getNombreUsuario(p.users_id)}</td>
                                                    <td className="text-right"><strong style={{ fontSize: '0.9rem' }}>${Math.round(p.valor_total).toLocaleString('es-CO')}</strong></td>
                                                    <td className="text-center">
                                                        {est === 1 && <div className="d-flex flex-column align-items-center"><span className="status-pill" style={{ background: 'rgba(23, 162, 184, 0.1)', color: '#17a2b8', border: '1px solid rgba(23, 162, 184, 0.2)' }}>Activo</span><span style={{ fontSize: '0.65rem', color: '#faad14', fontWeight: 700 }}>Pend: ${Math.round(p.saldo_disponible).toLocaleString('es-CO')}</span></div>}
                                                        {est === 3 && <span className="status-pill status-paid">Pagado</span>}
                                                        {est === 0 && <span className="status-pill status-active" style={{ background: '#f0f0f0', color: '#8c8c8c', border: '1px solid #d9d9d9' }}>Borrador</span>}
                                                        {est === 2 && <span className="status-pill status-void">Anulado</span>}
                                                    </td>
                                                    <td className="text-center" onClick={e => e.stopPropagation()}>
                                                        <button 
                                                            className="btn btn-sm btn-light shadow-sm" 
                                                            type="button" 
                                                            onClick={() => handleAbrirAcciones(p)}
                                                            style={{borderRadius: '8px', padding: '4px 12px', background: 'white', color: '#323a45', border: '1px solid #f0f0f0'}}
                                                        >
                                                            <i className="fas fa-ellipsis-v"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            <div className="card-footer bg-white border-0 py-3">
                                <div className="d-flex justify-content-between align-items-center flex-wrap" style={{ gap: '12px' }}>
                                    <div style={{ color: '#8c8c8c', fontSize: '0.8rem', flex: '1 1 auto' }}>
                                        Mostrando <strong>{presupuestos.length === 0 ? 0 : indicePrimerRegistro + 1}</strong> a <strong>{Math.min(indiceUltimoRegistro, presupuestos.length)}</strong> de <strong>{presupuestos.length}</strong> presupuestos
                                    </div>

                                    <nav>
                                        <ul className="pagination pagination-sm mb-0" style={{ gap: '5px' }}>
                                            <li className={`page-item ${paginaActual === 1 || totalPaginas === 0 ? 'disabled' : ''}`}>
                                                <button type="button" className="page-link border-0 shadow-sm" onClick={() => cambiarPagina(paginaActual - 1)} disabled={paginaActual === 1 || totalPaginas === 0} style={{ borderRadius: '8px', padding: '6px 12px', background: '#f8f9fa', color: '#323a45' }}>
                                                    <i className="fas fa-chevron-left"></i>
                                                </button>
                                            </li>

                                            {totalPaginas < 1 ? (
                                                <li className="page-item disabled">
                                                    <span className="page-link border-0 shadow-sm" style={{ borderRadius: '8px', padding: '6px 12px', background: '#f8f9fa', color: '#8c8c8c' }}>1</span>
                                                </li>
                                            ) : (
                                                getPaginationItems(paginaActual, totalPaginas).map((item, idx) => {
                                                    if (item === null) {
                                                        return (
                                                            <li key={`ellipsis-${idx}`} className="page-item disabled">
                                                                <span className="page-link border-0 shadow-sm" style={{ borderRadius: '8px', padding: '6px 12px', background: '#f8f9fa', color: '#8c8c8c' }}>...</span>
                                                            </li>
                                                        );
                                                    }
                                                    return (
                                                        <li key={item} className={`page-item ${paginaActual === item ? 'active' : ''}`}>
                                                            <button
                                                                type="button"
                                                                className="page-link border-0 shadow-sm"
                                                                onClick={() => cambiarPagina(item)}
                                                                style={{
                                                                    borderRadius: '8px',
                                                                    padding: '6px 12px',
                                                                    background: paginaActual === item ? '#17a2b8' : '#f8f9fa',
                                                                    color: paginaActual === item ? 'white' : '#323a45',
                                                                    fontWeight: 700,
                                                                    border: 0
                                                                }}
                                                            >
                                                                {item}
                                                            </button>
                                                        </li>
                                                    );
                                                })
                                            )}

                                            <li className={`page-item ${paginaActual === totalPaginas || totalPaginas === 0 ? 'disabled' : ''}`}>
                                                <button type="button" className="page-link border-0 shadow-sm" onClick={() => cambiarPagina(paginaActual + 1)} disabled={paginaActual === totalPaginas || totalPaginas === 0} style={{ borderRadius: '8px', padding: '6px 12px', background: '#f8f9fa', color: '#323a45' }}>
                                                    <i className="fas fa-chevron-right"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
            </div>
            <Footer showToast={false} delay={0} />

            <ToastContainer className="toast-exito">
                <Toast onClose={() => setShowToast(false)} show={showToast} delay={4000} autohide>
                    <Toast.Body>
                        <i className="fas fa-check-circle mr-2"></i>
                        {toastMsg}
                    </Toast.Body>
                </Toast>
            </ToastContainer>

            {/* MODAL DE ACCIONES RÁPIDAS */}
            {showModalAcciones && presupuestoAccion && (
                <div className="modal fade show" style={{display: 'block', background: 'rgba(0,0,0,0.5)', zIndex: 9999}}>
                    <div className="modal-dialog modal-dialog-centered modal-sm">
                        <div className="modal-content border-0 shadow-lg" style={{borderRadius: '20px', overflow: 'hidden'}}>
                            <div className="modal-header border-0 pb-0" style={{background: '#f8f9fa'}}>
                                <h6 className="modal-title font-weight-bold" style={{color: '#323a45'}}>OPCIONES N° {presupuestoAccion.numero_presupuesto}</h6>
                                <button type="button" className="close" onClick={() => setShowModalAcciones(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body p-3">
                                <div className="list-group list-group-flush">
                                    <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" 
                                            onClick={() => { vistaPreviaPresupuesto(presupuestoAccion.id); setShowModalAcciones(false); }}
                                            style={{borderRadius: '12px', background: '#f0f5ff'}}>
                                        <i className="fas fa-eye mr-3" style={{color: '#17a2b8'}}></i> <span style={{fontWeight: 600}}>Ver detalle</span>
                                    </button>

                                    {parseInt(presupuestoAccion.estado) === 0 && (
                                        <>
                                            <Link to={`/editar-presupuesto/${presupuestoAccion.id}`} className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" style={{borderRadius: '12px'}}>
                                                <i className="fas fa-edit mr-3" style={{color: '#ffc107'}}></i> <span style={{fontWeight: 600}}>Editar</span>
                                            </Link>
                                            <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" 
                                                    onClick={() => handleCambioRapidoEstadoAcciones(presupuestoAccion.id, 1)}
                                                    style={{borderRadius: '12px'}}>
                                                <i className="fas fa-check-circle mr-3" style={{color: '#28a745'}}></i> <span style={{fontWeight: 600}}>Aprobar</span>
                                            </button>
                                            <div className="dropdown-divider"></div>
                                            <button className="list-group-item list-group-item-action border-0 d-flex align-items-center text-danger" 
                                                    onClick={() => eliminarPresupuesto(presupuestoAccion.id)}
                                                    style={{borderRadius: '12px'}}>
                                                <i className="fas fa-trash-alt mr-3"></i> <span style={{fontWeight: 600}}>Eliminar</span>
                                            </button>
                                        </>
                                    )}

                                    {parseInt(presupuestoAccion.estado) === 1 && (
                                        <>
                                            <Link to={`/editar-presupuesto/${presupuestoAccion.id}`} className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" style={{borderRadius: '12px'}}>
                                                <i className="fas fa-edit mr-3" style={{color: '#ffc107'}}></i> <span style={{fontWeight: 600}}>Editar</span>
                                            </Link>
                                            <Link to={`/crear-factura?presupuesto_activo=${presupuestoAccion.id}`} className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" style={{borderRadius: '12px'}}>
                                                <i className="fas fa-file-invoice-dollar mr-3" style={{color: '#17a2b8'}}></i> <span style={{fontWeight: 600}}>Factura Electrónica</span>
                                            </Link>
                                            <Link to={`/crear-factura-no-electronica?presupuesto_activo=${presupuestoAccion.id}`} className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" style={{borderRadius: '12px'}}>
                                                <i className="fas fa-receipt mr-3" style={{color: '#6c757d'}}></i> <span style={{fontWeight: 600}}>Factura No Elect.</span>
                                            </Link>
                                            <div className="dropdown-divider"></div>
                                            <button className="list-group-item list-group-item-action border-0 d-flex align-items-center text-danger" 
                                                    onClick={() => handleCambioRapidoEstadoAcciones(presupuestoAccion.id, 2)}
                                                    style={{borderRadius: '12px'}}>
                                                <i className="fas fa-ban mr-3"></i> <span style={{fontWeight: 600}}>Anular Presupuesto</span>
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ListadoPresupuestos;